module.exports = __webpack_public_path__ + "images/ico-device.svg?53ef12e198dcec0007a743d8cf5e0193";